export default {
	language: "Français",//法语//Allemand
	sanqi: {
		zhoushi: "Graphique des tendances",
		biaoti: "Crypto - Currency Trading in High Liquidity Markets",
		xiangqing: "De nombreuses années d'expérience opérationnelle offrent aux utilisateurs un environnement commercial riche, flexible, stable, sûr et fiable",
		Global: "Aménagement écologique mondial",
		Bank: "Sécurité bancaire",
		Focus: "Se concentrer sur l'expérience utilisateur",
		Convenient: "Facilitation des transactions",
		project: "Système mondial de gestion de l &amp; apos; expansion et de l &amp; apos; exploitation des projets, avec des centres locaux du commerce des services dans de nombreux pays",
		level: "Système de portefeuille bancaire, contrôle des risques financiers en temps réel et authentification multidimensionnelle, l'équipe de sécurité financière a fourni de multiples garanties pour la sécurité des fonds au cours de la dernière décennie",
		polish: "Affinez soigneusement les détails pour rendre l'interface utilisateur et l'interaction plus confortables étape par étape, et le commerce peut devenir un plaisir visuel",
		Android: "Prise en charge de l'exploitation des terminaux Android, IOS et Web pour contrôler l'information sur le marché, les marchés mondiaux et les transactions en temps réel n'importe quand, n'importe où",
		Download: "Télécharger le client mobile et échanger librement n'importe quand, n'importe où",
		Palm: "Palm Trading",
		Trade: "N'importe quand, n'importe où.",
		flow: "Expérience de mobilité",
		Smooth: "Fonctionnement fluide pour une expérience plus agréable",
		Real: "Offre en temps réel",
		time: "Mise à jour en temps réel pour vous tenir au courant des tendances du marché",
		Rapid: "Charge rapide",
		Experience: "Charge rapide",
		Join: "Commencez votre voyage contractuel",
		Please: "Veuillez entrer votre téléphone / courriel dans la zone d'entrée ci - dessous pour vous inscrire à Azbit-usa",
		enter: "Veuillez saisir votre courriel ou votre numéro de téléphone mobile",
		Register: "Inscription",

		regulatory:'licence réglementaire',
		regulatory_info:"Uncleblock est une société de services financiers et monétaires conforme à la loi sous la supervision du CANAFE du Canada (Centre canadien d'analyse des transactions et des rapports financiers) et de la SEC des États-Unis (US Securities and Exchange Commission). Uncleblock se conformera à toutes les lois et réglementations applicables dans chaque juridiction dans laquelle elle opère sur la base d'une licence financière. ",
		canada:'Canada (sous surveillance)',
		certnum:'numéro de certificat réglementaire',
		dateissue:"date d'émission",
		veriurl:'URL de vérification canadienne',
		
		white_paper: 'papier blanc',
	},
	song: {
		low:'Veuillez saisir l ancien mot de passe',
	    jgsxf: "Déduction des frais de service pour les commandes passées dans le cadre d'un contrat à grande vitesse",
	    jgbj: "Déduction du principal pour les commandes passées dans le cadre de contrats à grande vitesse",
	    jgks: "Règlement des pertes",
	    jgyl: "Clôture rapide des commandes contractuelles et règlement des bénéfices",
	    htcz: "background recharge",
	    htshcz: "background audit recharge",
	    bbhr: "transfert de compte en monnaie",
	    bbhc: "transfert de compte en monnaie",
	    pccl: "traitement des fonds de clôture",
	    gmsxf: "frais de manutention déduits des ventes suspendues",
	    ggsxf: "soumettre des opérations de levier, déduction faite des frais de service",
		ggbzj: "soumission d'opérations à effet de levier, déduction faite de la marge",
	    gbdj: "submit pending buy Freeze",
	    gbkc: "submit pending purchase deduction",
	    gsdj: "soumettre le gel des ventes",
	    gskc: "submit Suspended sales deduction",
	    tbsbjs: "Échec de la collecte de devises, réduction du solde de verrouillage",
	    tbsbch: "Échec du retrait de la monnaie, verrouillage du retrait du solde",
	    tbcg: "retrait réussi",
	    gyf: "opération de levier, frais au jour le jour",
		gghr: "transfert de compte à effet de levier",
	    gghc: "transfert de compte à effet de levier",
	    tbdj: "demande de retrait de devises et de gel du solde",
	    tbkc: "demande de retrait de monnaie pour déduire le solde",
	    mhxh: "Blind Box Consumption",
	    mhhq: "Blind Box Getting",
	    msxf: "déduction des frais de service pour les commandes passées en vertu d'un contrat de seconde durée",
	    mbj: "déduction du principal pour les commandes passées dans le cadre d'un contrat de seconde durée",
	    mks: "Second Contract Order, Loss Settlement",
	    myl: "Second Contract Order Closing, profit Settlement",
	    mhr: "Second Contract account Transfer",
	    mhc: "Second Contract account Transfer",
	    sfsczj: "Libération de l'exploitation minière verrouillée pour augmenter les actifs disponibles",
	    sfsckc: "« libération de l'exploitation minière verrouillée pour déduire les actifs gelés »",
	    sczj: "lock - out Mining increases freezed assets",
	    sckc: "lock - out Mining deducts available assets",
	    scsy: "lock - out Mining Benefits available assets",
	    ahtcz: "background recharge Notes",
	    xcbx: "Règlement de clôture des commandes de contrats à grande vitesse sans assurance effective et sans changement de fonds",
		bbjx:"Currency transaction: User cancel Buying and Unlock",
		bbth:"Currency transaction: User cancel hanging buy return",
		wtcd_t:"Annulation de la Commission",
		wtcd_b:"Annulation de la commande confiée et retour de la garantie",
		bxju_p:"Résiliation de l'assurance",
		bxju_s:"Annulation de l'assurance, déduction faite du montant assuré",
		bxju_b:"Annulation de l'assurance, déduction faite du montant assuré",
	},
	iesan: {
		li_a: 'Concentrez - vous et laissez - nous le reste.',
		li_b: 'Analyse automatisée de l investissement - selon l exploitation minière verrouillée de l Azbit-usa, il est possible d établir des comptes hautement autonomes pour les principales paires de devises de négociation des investisseurs avec des idées de négociation personnalisées - Personnaliser la colonne de retrait de fonds, la colonne de ratio de position et la colonne de ratio d alerte en fonction des différents types de clients. Prise en charge complète des opérateurs présentant des tolérances de risque différentes sur le marché. Emprunt de devises pour le compte réservé - la plate - forme fournit l emprunt de devises pour l exploitation minière en entrepôt verrouillé. Vous n avez besoin que de 50% de l actif numérique du compte pour obtenir l emprunt de devises pour le financement de la plate - forme.',
		zuidi: 'Quantité minimale',
		b_liord: "Commande de boîte aveugle",
		b_zhomg: "Blind Box winning",
		b_xiaohao: "Consommation",
		b_mangheli: "Sac cadeau en boîte aveugle",
		b_qingsong: "Découvrez facilement le super sac cadeau",
		b_kaiqi: "Ouvrir la boîte aveugle",
		b_xuyao: "Nécessaire pour ouvrir la boîte aveugle actuelle",
		b_dangqian: "Solde actuel",
		b_quxiao: "Annulation",
		b_ok: "C'est sûr.",
		b_cuocang: "Gagner de l'argent en fermant les magasins",
		b_dindan: "Commande de boîte aveugle",
		b_genduo: "Charger plus",
		b_wabao: "Trésor minier",
		b_jiandan: "L'extraction minière est plus facile et plus facile à obtenir des récompenses",
		b_cung: "Gagner de l'argent en fermant les magasins",
		b_shouyi: "Total des recettes",
		b_zhiyao: "Quantité de gage",
		b_qianbao: "Solde du portefeuille",
		b_goumai: "Achats",
		b_zhjuanbi: "Gagner de l'argent en fermant les magasins",
		b_num: "Nombre de pièces en stock",
		b_yuji: "Total des recettes prévues",
		b_jin: "Proche",
		b_rinianhua: "Annualisation quotidienne de référence",
		b_suochang: "Période de verrouillage",
		b_gtou: "Achats",
		b_jilu: "Enregistrement des serrures",
		b_biaohuao: "Numéro du projet",
		b_bizhong: "Monnaie",
		b_shuliang: "Nombre de pièces en stock",
		b_jixi: "Total des intérêts",
		b_suocang: "Temps de verrouillage",
		b_shijan: "Échéance",
		b_zhuangtai: "Statut",
		b_jinxin: "En cours",
		b_jieshu: "Terminé.",
		b_zhenqui: "Veuillez saisir la quantité correcte",
		b_tian: "Oh, mon Dieu.",
		b_mei: "Il n'y en a plus.",
		b_maghe: "Boîte aveugle",
		b_wakuang: 'Mine lock - out',
		levermin: "Cantidad inferior al mínimo"
	},
	chongbi: {
		zaixian:"Service à la clientèle en ligne",
		fuzhi:"Copier l'étiquette",
		huazhuan:"Tourner",
		bizhong:"Monnaie",
		keyong:"Solde disponible",
		cong:"From",
		zhi:"To",
		num:"Quantité de transfert",
		shuru:"Veuillez entrer la quantité de rotation",
		whatsapp:"Veuillez saisir le compte WhatsApp",
		youxiang:"Boîte aux lettres",
		superior: "Mon subordonné",
		tiem: "Time",
		tit: "Mes membres",
		group: "Nombre d'équipes",
		not: "Pas de membre pour le moment",
		qukuai: "Blockchain School",
		fabi: "Transactions en monnaie française",
		gonggao: "Annonce",
		xitong: "Article système",
		yonghu: "Support utilisateur",
		bangzhu: "Centre d'aide",
		shouyi: "Règles de rendement",
		xinwen: "News Center",
		xinshou: "Aide aux débutants",
		jiaoyi: "Règles de transaction",
		kuaixun: "Flash",
	},
	// 导航
	header: {
		wakuang: "Lockbox Mining",
		miaohy: "Contrat à grande vitesse",
		home: "Page d'accueil",
		markets: "Marché",
		fiat: "Transactions en monnaie française",
		c2c: "C2c transaction",
		exchange: "Opérations en monnaie",
		lever: "Transaction contractuelle",
		myshop: "Mon magasin",
		assets: "Mes biens",
		help: "Centre d'aide",
		login: "Login",
		sign: "Inscription",
		accountSet: "Paramètres du compte",
		tradeLog: "Relevé des transactions",
		receiveSet: "Paramètres de collecte",
		identify: "Authentification",
		jchange: "Change de monnaie",
		logout: "Exit login",
		themedark: "Mode nuit",
		themeday: "Mode jour",
	},
	// 登录注册
	lg: {
		login: "Login",
		register: "Inscription",
	},
	// 首页
	home: {
		vol: "Quantité 24h",
		c01: "« la principale Plateforme mondiale de négociation d’actifs numériques»",
		c02: "« fournir des services sécurisés et fiables de négociation et de gestion d'actifs numériques à des millions d'utilisateurs dans plus de 130 pays à travers le monde »",
		c03: "Sûr et fiable",
		c04: "5 ans d'expérience dans les services financiers d'actifs numériques",
		c05: "Professional Distributed Architecture and Anti - DDOS attack Systems",
		c06: "Global Ecological Layout",
		c07: "Création de centres de services commerciaux localisés dans plusieurs pays",
		c08: "Créer un écosystème de chaînes de blocs intégrant plusieurs formes d'affaires",
		c09: "User First",
		c10: "Mise en place d'un mécanisme de paiement anticipé",
		c11: "Création d'un fonds de protection des investisseurs",
		c12: "Transactions multiplateforme n'importe quand, n'importe où",
		c13: "Couvre plusieurs plateformes IOS, Android et Windows et prend en charge toutes les fonctions d'affaires",
		sweep: "Scan code Download",
		android: "Android",
		pinput: "Veuillez saisir votre numéro de courriel ou de téléphone",
		atrade: "Inscrivez - vous à un compte ie - x Global station pour commencer le voyage commercial"
	},
	// 底部
	foo: {
		about: "À propos de nous",
		support: "Support utilisateur",
		contact: "Contactez - nous",
		qq: "Service à la clientèle qq",
		email: "Contact mailbox",
	},
	// 行情
	market: {
		exchange: "Monnaie",
		selfmarket: "Self - select",
		allmarket: "Tous les marchés",
		symbol: "Paire de transactions",
		newprice: "Dernier prix",
		change: "Augmentation",
		highprice: "Prix maximum",
		lowprice: "Prix le plus bas",
		vol: "Quantité 24h",
	},
	// 公共交易
	td: {
		purchase: "Prix d'achat",
		transaction: "Prix de transaction",
		service: "Frais de manutention",
		profit: "Profits et pertes",
		buy: "Acheter",
		sell: "Vendre",
		currency: "Monnaie",
		num: "Quantité",
		time: "Time",
		limit: "Limites",
		price: "Prix unitaire",
		method: "Mode de paiement",
		total: "Total",
		inwant: "Veuillez entrer pour",
		do: "Action",
		more: "Charger plus",
		nomore: "Plus rien",
		nodata: "Pas de données pour le moment",
		trade: "Transaction",
		buynum: "Quantité achetée",
		sellout: "Vendre",
		buyin: "Acheter",
		all: "Tous",
		allbuy: "Acheter tout",
		allsell: "Vendre tout",
		buytotal: "Veuillez entrer le montant total que vous souhaitez acheter",
		selltotal: "Veuillez entrer le montant total à vendre",
		buyallnum: "Veuillez entrer la quantité à acheter",
		sellallnum: "Veuillez entrer la quantité à vendre",
		tradeTotal: "Total des transactions",
		doceil: "Annuler automatiquement en secondes",
		place: "Commande",
		waitpay: "À payer",
		paycode: "Code de paiement",
		finished: "Terminé",
		ceiled: "Annulé",
		payed: "Payé",
		nofinish: "Incomplet",
		buyer: "Acheteur",
		seller: "Vendeur",
		callWay: "Contact",
		placeTime: "Temps de commande",
		renum: "Numéro de référence",
		canceil: "Annuler",
		confirm: "Confirmer",
		pwd: "Veuillez saisir le mot de passe de la transaction",
		coincode: "Unit é monétaire",
		pcoin: "Veuillez sélectionner l'unit é monétaire"
	},
	// 法币交易
	fat: {
		// LegalPayDetail
		orderLog: "Carnet de commandes",
		fatdLog: "Opérations en monnaie française",
		shoper: "Marchand",
		faLog: "Opérations en monnaie française",
		tdType: "Type de transaction",
		odStatus: "État de la commande",
		pwaitPay: "Veuillez attendre le paiement de l'acheteur",
		odFinish: "Commande terminée",
		odCeil: "Commande annulée",
		odPay: "Payé, veuillez vérifier les informations de paiement",
		tdCeil: "Annuler la transaction",
		pCeil: "Si vous avez payé le vendeur, n'annulez jamais la transaction",
		paySure: "Confirmation de paiement",
		pdopay: "Veuillez confirmer que vous avez payé le vendeur",
		badClick: "Un clic malveillant va geler le compte directement",
		receivePay: "Confirmation de réception",
		payReceive: "Veuillez confirmer que l'acheteur vous a payé",
		receivePays: "Confirmer le reçu",
		// LegalPay
		payPlease: "Please pay",
		tdPrice: "Prix unitaire de transaction",
		tdNum: "Nombre de transactions",
		payinfo: "Informations sur le paiement",
		banknum: "Compte bancaire",
		realName: "Vrai nom",
		shoperZname: "Sous - branche Merchant",
		shoperNum: "Compte commercial",
		odCeil: "Annuler la commande",
		imPay: "J'ai payé, cliquez sur OK",
		// LegalSeller
		register_time: "Heure d'inscription",
		odtotal: "Liste de montage",
		odmonth: "30 jours de commande",
		odfinish: "Feuille d'achèvement",
		odrate: "Taux d'achèvement",
		submit: "Publier",
		phone: "Mobile",
		mysell: "Ma vente",
		mybuy: "Mon achat",
		realAuth: "Authentification par nom réel",
		advAuth: "Certification avancée",
		linebuy: "Acheter en ligne",
		linesell: "Vendre en ligne",
		tipPay: "S'il vous plaît contacter le commerçant dans les 24 heures pour le paiement, plus de 24 heures sera automatiquement annulé",
		notlow: "Ne peut pas être inférieur au minimum",
		nothigh: "Ne peut pas dépasser la limite maximale",
		notnum: "Ne peut pas dépasser la quantité maximale",
		// LegalShopDetail
		type: "Type",
		status: "Status",
		seeOrder: "Voir l'ordre",
		withdraw: "Retrait",
		abnormal: "Exception",
		lowershelf: "En bas",
		protection: "En action",
		apply: "Demande de protection des droits",
		psType: "Veuillez sélectionner un type",
		pselect: "Veuillez sélectionner",
		alipay: "AliPay",
		wechat: "Wechat",
		bank: "Carte bancaire",
		minNum: "Volume minimal des transactions",
		maxNum: "Volume maximal des transactions",
		wantBuy: "Acheter",
		pnums: "Veuillez entrer la quantité",
		pmin: "Veuillez entrer le volume minimal des transactions",
		pmax: "Veuillez saisir le volume maximal de la transaction",
		pnot: "Le volume maximal ne peut être inférieur au volume minimal",
		// MyLegalShops
		myshops: "Mon magasin",
		name: "Name",
		fiatSub: "De la monnaie française",
		shoper_balance: "Balance commerciale",
		enterShop: "Entrez dans le magasin",
		// shop_legal_pay_detail
		payedWait: "Payé, à confirmer après vérification",
		yes: "Oui",
		no: "Non",
		sd: "Solde verrouillé",
		journal: "Balance log",
		business: "Marchand",
		user: "Utilisateur",
		backdone: "Retiré",
		busbalance: "Balance commerciale",
		userbalance: "Solde utilisateur",
	},
	ctc: {
		ctc: "C2c",
		myRelease: "Mon c2c publié",
		myTrade: "Le c2c que j'ai échangé",
		and: "Oui",
		balance: "Solde",
		buynum: "Quantité achetée",
		sellnum: "Ventes",
		bankTransfer: "Virement bancaire",
		payim: "Doit être payé en personne",
		pbuyNum: "Veuillez entrer la quantité achetée",
		pprice: "Veuillez entrer le prix unitaire",
		payway: "Veuillez sélectionner le mode de paiement",
		psellNum: "Veuillez entrer la quantité vendue",
		suerePlace: "Êtes - vous sûr de passer la commande?",
		detail: "Détails",
		payinfo: "Informations sur le paiement",
		Payee: "Bénéficiaire",
		total: "Total",
		name: "Name",
		cardnum: "Numéro de carte",
		receivePay: "Confirmer le reçu",
		ceilConfirm: "Confirmer l'annulation de la transaction?",
		paySeller: "S'il vous plaît confirmer que vous avez payé le vendeur, cliquez malicieusement sur le compte sera gelé",
		payBuyer: "Veuillez confirmer que vous avez acheté des informations sur le paiement à domicile",
		account: "Numéro de compte",
		sellerPay: "Veuillez confirmer que l'acheteur vous a payé?",
		payattion: "S'il vous plaît payer le vendeur dès que possible après confirmation de paiement, cliquez malicieusement pour geler le compte directement",
		log: "C2c completed order",
	},
	// 合约
	lever: {
		purchase: "Prix d'achat",
		Expected: "Estimation des profits et pertes",
		countdown: "Compte à rebours",
		second: "Second",
		jiaoyinum: "Quantité",
		houmaicg: "Achat réussi",
		nowentrust: "Délégation actuelle",
		hisentrust: "Délégation historique",
		lvchi: "Position contractuelle",
		all: "Tous",
		or: "Ou",
		gotrade: "Commencer la transaction",
		tdrecord: "Transaction",
		dealed: "Conclu",
		notdeal: "Non conclu",
		loading: "Chargement...",
		entotal: "Total délégué",
		canuse: "Disponible",
		std: "Marché",
		xtd: "Limite de prix",
		pprice: "Veuillez entrer le prix",
		phand: "Veuillez entrer la quantité achetée",
		phandsell: "Veuillez entrer la quantité vendue",
		pwd: "Mot de passe",
		ppwd: "Veuillez saisir le mot de passe de la transaction",
		psw: "Mot de passe de transaction",
		equal: "égal à",
		times: "X",
		timed: "Multiple",
		hand: "Main",
		miao: "s",
		miaos: "Secondes",
		hands: "Nombre de mains",
		ptimes: "Please select multiple",
		phands: "Veuillez sélectionner le nombre de mains",
		contractVal: "Valeur marchande du contrat",
		bail: "Dépôt de garantie",
		canBail: "Marge disponible",
		charge: "Frais de service de transaction",
		domore: "Acheter (plus)",
		doshort: "Vendre (Court)",
		dmore: "Soyez plus",
		dshort: "Short",
		sureOd: "Confirmer la commande",
		noless: "Le nombre de mains ne peut être inférieur à",
		nomore: "Le nombre de mains ne peut pas être supérieur à",
		tdnum: "Volume des échanges",
		risk: "Taux de risque",
		allloss: "Résultat total de la position",
		onehouse: "Une clé pour fermer la position",
		type: "Type",
		entrustPrice: "Prix délégué",
		openPrice: "Prix d'ouverture",
		nowPrice: "Prix courant",
		styPrice: "Stop profit price",
		stsPrice: "Stop loss price",
		openTime: "Heure d'ouverture",
		closeTime: "Temps de fermeture",
		rate: "Frais de manutention",
		nightFee: "Frais de nuit",
		loss: "Profits et pertes",
		setloss: "Set plug stop loss",
		expectProfit: "Bénéfice attendu",
		expectLoss: "Perte prévue",
		allClose: "Tout fermer",
		moreClose: "Seulement plus simple",
		nullClose: "Document vide seulement",
		sureClose: "Confirmer la clôture?",
		thanZearo: "La valeur doit être supérieure à 0",
		listin: "En liste",
		tdin: "En transaction",
		closein: "En position fermée",
		closed: "Fermé",
		revoked: "Annulé",
		revokeOrder: "Êtes - vous sûr de vouloir annuler la commande?",
		ping: "Fermeture",
		revoke: "Annulation",
		sureping: "Tu es sûr de fermer?",
		thanzone: "La valeur doit être supérieure à 0",

		profitability: 'Rentabilité',
		profit_: 'Profit',
	},
	// 币币
	cuy: {
		direction: "Direction",
		total: "Total",
		price: "Prix",
		sell: "Vendre",
		buy: "Buy",
		allStation: "Transaction globale",
		buyPrice: "Prix d'achat",
		buynum: "Quantité achetée",
		sellPrice: "Prix de vente",
		sellnum: "Ventes",
		tdPrice: "Montant de la transaction",
		or: "Ou",
		tdStart: "Commencer la transaction",
		pbPrice: "Veuillez entrer le prix d'achat",
		pbNum: "Veuillez entrer le montant d'achat",
		psPrice: "Veuillez entrer le prix de vente",
		psNum: "Veuillez entrer la quantité vendue",
		fixPrice: "Limite de prix",
		Mtrans: "Marché",
		available: "Disponible",
		revoke: "Annuler",
		loading: "En charge",
		confirmCancel: "Êtes - vous sûr de vouloir annuler?",
		confirm: "OK",
		cancel: "Annuler",
		nomore: "Plus de données",
		evelPrice: "Prix moyen de transaction"
	},
	// 资产
	asset: {
		text1:"Adresse remplie de monnaie",
		text2:"Veuillez saisir une adresse remplie de monnaie",
		text3:"Quantité remplie de monnaie",
		text4:"Veuillez entrer la quantité remplie de monnaie",
		text5:"Soumettre des informations de recharge",
		miao_account: "Compte de contrat à grande vitesse",
		assets: "Actifs",
		currency_account: "Compte en monnaie",
		lever_account: "Compte contractuel",
		fince_account: "Compte en monnaie française",
		change_account: "Compte de transaction",
		assets_hua: "Transfert de fonds",
		all_assets: "Total des actifs convertis",
		currency: "Monnaie",
		canuse: "Disponible",
		frezz: "Freeze",
		conversion: "Plier",
		charging: "Recharge",
		withdraw: "Retrait de pièces",
		address_bind: "Lier l'adresse de retrait de monnaie",
		address_withdraw: "Gestion de l'adresse de retrait de monnaie",
		record: "Record",
		address_charge: "Adresse remplie de monnaie",
		address_width: "Adresse de retrait de monnaie",
		copy: "Copier",
		ercode: "Code QR",
		reminder: "Conseils chaleureux",
		notcharge: "Ne rechargez aucun actif non USDT à l'adresse ci-dessus, sinon les actifs ne seront pas récupérés",
		support: "La recharge ne prend en charge que la méthode d'envoi simple. Veuillez comprendre que la recharge avec d'autres méthodes (envoyer toutes) ne peut pas être affichée temporairement.",
		minnum: "Quantité minimale de retrait",
		ratenum: "Frais de manutention",
		havenum: "Quantité reçue",
		from: "From",
		to: "To",
		transfer: "Tourner",
		tfnum: "Quantité de transfert",
		ptfnum: "Veuillez saisir le minimum",
		dtfnum: "Nombre de rotations pour",
		canbalance: "Solde disponible",
		sureConfirm: "Confirmer le transfert",
		moneyRecord: "Documents financiers",
		pNum: "Veuillez entrer la quantité de rotation",
		leverUse: "Compte contractuel disponible",
		legalUse: "Compte en monnaie française disponible",
		changeUse: "Compte de transaction disponible",
		look: "Voir",
		chargeRecord: "Enregistrement de remplissage de monnaie",
		status: "État de la trace",
		noopen: "Cette fonction n'est pas encore ouverte",
		enterAdderses: "Veuillez saisir l'adresse de retrait de monnaie",
		enterNum: "Veuillez entrer la quantité de retrait de monnaie",
		lessMin: "La quantité de retrait de monnaie saisie est inférieure au minimum",
		tips01: "Ne rechargez aucun autre actif à l'adresse ci - dessus, sinon l'actif ne sera pas récupéré.",
		tips02: "La recharge ne prend en charge que la méthode d'envoi simple. Veuillez comprendre que la recharge avec d'autres méthodes (envoyer toutes) ne peut pas être affichée temporairement.",
		beizhu: "Remarques",
		pbeizhu: "Veuillez entrer une note",
		add: "Ajouter",
		addressList: "Liste d'adresses",
		delete: "Supprimer",
		norec: "Pas d'enregistrement pour le moment",
		selectCurrency: "Veuillez sélectionner une devise",
		chainType: "Type de chaîne"
	},
	// 账户设置
	set: {
		mycode2: "Mon code d'autorisation",
		copycode2: "Copier le Code d'autorisation",
		uaccont: "Votre niveau de sécurité de compte:",
		strong: "Fort",
		middle: "Moyen",
		weak: "Faible",
		min: "Faible",
		heigh: "High",
		complete: "Améliorer plus d'informations pour assurer la sécurité du compte",
		mycode: "Mon code d'invitation",
		copycode: "Copier le Code d'invitation",
		bindphone: "Lier le téléphone",
		bindemail: "Lier la boîte aux lettres",
		loginpwd: "Mot de passe de connexion",
		noBind: "Non lié",
		binds: "BIND",
		bind: "Dégrouper",
		binded: "Lié",
		net: "Il y a un risque de vol de votre compte Internet, nous vous recommandons de changer votre mot de passe régulièrement pour protéger votre compte.",
		reset: "Modifier",
		setPsw: "Définissez le mot de passe de la transaction pour sécuriser la transaction.",
		goSet: "To set",
		bindAccount: "BIND Exchange account",
		duihuan: "Lier les comptes pour l'échange de points",
		copysuccess: "Copie réussie",
		copyfail: "La réplication a échoué",
		recopy: "Veuillez copier à nouveau",
		account: "Compte",
		detail: "Détails",
		val: "Montant",
		forgetPsw: "Mot de passe oublié",
		code: "Code de vérification",
		getCode: "Obtenir le Code de vérification",
		setPsw: "Définir le mot de passe",
		enterPsw: "Veuillez saisir un mot de passe",
		pswFalse: "Les mots de passe entrés deux fois sont incohérents",
		enterPswagain: "Veuillez saisir à nouveau votre mot de passe",
		jsetPsw: "Définir le mot de passe de la transaction",
		jenterPsw: "Veuillez saisir le mot de passe de la transaction",
		jenterPswagain: "Veuillez saisir à nouveau le mot de passe de la transaction",
		enterAccount: "Veuillez entrer le numéro de compte",
		enterCode: "Veuillez saisir le Code de vérification",
		accountFalse: "Le numéro de téléphone ou de courriel que vous avez entré n'est pas conforme aux règles!",
		second: "Second",
		sendCode: "Envoyer le Code de vérification",
		sendsucc: "Envoyé avec succès",
		enterPswTwo: "Veuillez saisir votre mot de passe deux fois",
		rest: "Restant",
		yes: "Oui",
		no: "Non",
		yorn: "Définir le mot de passe de la transaction",
	},
	// 身份认证
	auth: {
		identity: "Authentification",
		name: "Name",
		idcard: "Carte d'identité",
		upimg: "S'il vous plaît télécharger une photo d'identité. La première photo est à l'avant, la deuxième est à l'arrière, et la troisième est à l'avant de la photo d'identité tenue à la main.",
		submit: "Soumettre",
		auditing: "Audit en cours...",
		certified: "Certifié!",
		pname: "Veuillez saisir un nom",
		pidcard: "Veuillez entrer le numéro d'identification",
		pimg: "Veuillez télécharger l'image de votre carte d'identité!",
	},
	// 收款方式
	seting: {
		pmethod: "Méthode de collecte",
		truename: "Vrai nom",
		opening: "Nom de la Banque de dépôt",
		bank: "Numéro de carte bancaire",
		alipay: "Alipay account No.",
		wename: "Surnom Wechat",
		wechat: "Compte Wechat",
		pname: "Veuillez saisir un vrai nom",
		popen: "Veuillez saisir le nom de la Banque de dépôt",
		pcard: "Veuillez entrer le numéro de carte bancaire",
		palipay: "Veuillez saisir le numéro de compte Alipay",
		pwname: "Veuillez saisir un surnom Wechat",
		pwaccount: "Veuillez entrer votre compte Wechat",
		pimg1: "Wechat Collection Code",
		pimg2: "AliPay Collection Code"
	},
	// 帮助中心
	news: {
		seeall: "Voir tout",
		helpcenter: "Centre d'aide",
		back: "Retour",
		gonggao: "Annonce"
	},
	//登录
	login: {
		welcome: "Bienvenue à la connexion",
		phoneLogin: "Connexion mobile",
		emailLogin: "Connexion à la boîte aux lettres",
		account: "Numéro de compte",
		psw: "Mot de passe",
		login: "Login",
		nouser: "Pas encore utilisateur de ie - X?",
		goRegister: "Inscrivez - vous maintenant et commencez à négocier sur les principales plateformes de négociation d'actifs numériques au monde.",
		registerFree: "Inscription gratuite",
		psw6: "Le mot de passe ne peut pas être inférieur à six chiffres"
	},
	register: {
		register: "Inscription",
		phoneRegister: "Inscription au téléphone",
		emailRegister: "Inscription à la boîte aux lettres",
		country: "Nationalité",
		enterPhone: "Veuillez entrer votre numéro de téléphone",
		enterEmail: "Veuillez saisir une boîte aux lettres",
		psw16: "Mot de passe entre 6 et 16 bits",
		inviteCode: "Code d'invitation",
		sel: "Obligatoire",
		sel2: "Non requis",
		read: "J'ai lu et accepté",
		xieyi: "Accord utilisateur",
		tips01: "Les informations sur la nationalité ne peuvent pas être modifiées après l'enregistrement. Assurez - vous de les sélectionner honnêtement.",
		tips02: "Vérifiez que le message peut être mal jugé comme du spam, veuillez vérifier.",
		tips03: "Veuillez conserver votre compte ie - X et votre mot de passe de connexion correctement.",
		tips04: "N'utilisez pas le même mot de passe de connexion que les autres sites.",
		emailFalse: "La boîte aux lettres que vous avez saisie n'est pas conforme aux règles"
	},
	// 积分兑换
	jc: {
		title: "JC Exchange Digital Assets beau Platform",
		balance: "Solde",
		cannum: "Nombre de JC disponibles",
		new: "Dernier prix",
		exnum: "Quantité de change",
		pnum: "Veuillez saisir la quantité de JC",
		canex: "Quantité de beau convertible",
		exnow: "Change maintenant",
		record: "Change Record",
		exprice: "Prix de change",
		extime: "Change time",
		not: "Pas assez de points disponibles",
		usenum: "Nombre de JC utilisés",
		out: "EXIT",
		gotd: "To Deal"

	}

}



// WEBPACK FOOTER //
// ./src/lang/fr.js